import { connect } from 'react-redux';
import { getAddressesOfType } from '../reducer';
import AddressForm from './AddressForm';
export var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var account = _ref.account,
    user = _ref.user;
  var brazilianState = _ref2.brazilianState,
    countries = _ref2.countries,
    displayHeader = _ref2.displayHeader,
    _ref2$enableAddressSe = _ref2.enableAddressSelection,
    enableAddressSelection = _ref2$enableAddressSe === void 0 ? true : _ref2$enableAddressSe,
    organizationFieldRequired = _ref2.organizationFieldRequired,
    type = _ref2.type;
  return {
    addressOptions: getAddressesOfType({
      user: user,
      type: type
    }),
    brazilianState: brazilianState || false,
    countries: countries || account.countries,
    displayHeader: displayHeader !== undefined ? displayHeader : true,
    enableAddressSelection: user && user.addresses.length > 0 && enableAddressSelection,
    organizationFieldRequired: organizationFieldRequired !== undefined ? organizationFieldRequired : true
  };
};
export default connect(mapStateToProps)(AddressForm);